import React, { useState } from "react";
import { LuEye, LuEyeOff, LuKeyRound } from "react-icons/lu";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const NewPw = () => {
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Validate form on submission
  const validateForm = () => {
    let newErrors = {};
    if (!password) {
      newErrors.password = "New password is required.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Check if button should be enabled
  const isButtonDisabled =
    !password ||
    !confirmPassword ||
    password.length < 6 ||
    password !== confirmPassword;

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        setLoader(true);
        const resp = await Calling.updateAdminPw({ newpw: confirmPassword });
        if (resp?.status) {
          toast.success(resp?.message || "Password updated successfully!");
          navigate("/");
        } else {
          toast.error(resp?.message || "Failed to update password!");
        }
      } catch (error) {
        console.log(error);
        navigate("/");
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <>
      {loader ? (
        <Loader loader={loader} />
      ) : (
        <div className="w-full px-4 flex justify-center items-center h-screen py-8">
          <div className="ui-card-solid rounded-3xl p-5 sm:p-7 max-w-md w-full">
            <div className="flex flex-col items-center mb-5 sm:mb-6">
              <div className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30 mb-3">
                <LuKeyRound size={22} />
              </div>
              <h2 className="text-xl sm:text-2xl font-extrabold text-gradient-teal text-center">
                Reset Password
              </h2>
            </div>

            <form onSubmit={handleSubmit}>
              {/* New Password Input */}
              <div className="relative mb-4">
                <label className="block text-main-subfont text-sm sm:text-base mb-1">
                  New Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  className="ui-input w-full p-2 sm:p-3 rounded-xl text-sm sm:text-base"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="absolute top-8 sm:top-10 right-3 cursor-pointer text-main-subfont hover:text-brand-teal"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <LuEyeOff size={20} /> : <LuEye size={20} />}
                </span>
                {errors.password && (
                  <p className="text-red-300 text-xs sm:text-sm mt-1">
                    {errors.password}
                  </p>
                )}
              </div>

              {/* Confirm Password Input */}
              <div className="relative mb-4">
                <label className="block text-main-subfont text-sm sm:text-base mb-1">
                  Confirm Password
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm your password"
                  className="ui-input w-full p-2 sm:p-3 rounded-xl text-sm sm:text-base"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="absolute top-8 sm:top-10 right-3 cursor-pointer text-main-subfont hover:text-brand-teal"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <LuEyeOff size={20} />
                  ) : (
                    <LuEye size={20} />
                  )}
                </span>
                {errors.confirmPassword && (
                  <p className="text-red-300 text-xs sm:text-sm mt-1">
                    {errors.confirmPassword}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className={`w-full text-white py-2.5 rounded-xl transition text-sm sm:text-base font-semibold ${
                  isButtonDisabled
                    ? "bg-white/10 text-main-subfont cursor-not-allowed"
                    : "bg-gradient-to-r from-teal-500 to-cyan-500 shadow-lg shadow-teal-500/30 hover:brightness-110"
                }`}
                disabled={isButtonDisabled}
              >
                Update Password
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default NewPw;
